import request from '@/utils/bbs_request'
import ucenter_request from '@/utils/ucenter_request.js'

// 公共头部、底部
export function getPublic(params) {
  return request({
    url: 'index/index/getPcCommon',
    method: 'get',
    params: params
  })
}
export function getAgencyInfo(params) {
  return request({
    url: 'index/index/getAgencyInfo',
    method: 'get',
    params: params
  })
}
export function getAgencyInfoNew(params) {
  return request({
    url: 'api/Agency/getAgencyInfo',
    method: 'get',
    params: params
  })
}
// 获取弹窗
export function getImgUrl(params) {
  return request({
    url: '/admin/appSet/popWindowPop',
    method: 'get',
    params: params
  })
}
// 视频防作弊
export function videoPop(params) {
  return request({
    url: 'admin/appSet/videoPop',
    methods: 'get',
    params
  })
}
// 直播防作弊
export function livePop(params) {
  return request({
    url: '/admin/appSet/livePop',
    methods: 'get',
    params
  })
}
// 防作弊添加积分
export function addScore(params) {
  return request({
    url: '/admin/Appset/addScore',
    methods: 'get',
    params
  })
}

// 获取防作弊弹框按钮是否打开的状态
export function getUserPopup(params) {
  return ucenter_request({
    url: 'personal/Myinfo/getUserPopup',
    params: params,
    method: 'get'
  })
}
// 设置防挂机弹框状态
export function setUserPopup(params) {
  return ucenter_request({
    url: 'personal/Myinfo/setUserPopup',
    params: params,
    method: 'get'
  })
}

export function getButtom(params) {
  return request({
    url: 'index/index/getButtomMenuDes',
    method: 'get',
    params: params
  })
}

